import { FC } from 'react'
import { isInternalTester, isProductionHost } from 'src/utils/internalTester'
import styles from './internalTesterBadge.module.scss'

export const InternalTesterBadge: FC = () => {
  if (!isInternalTester()) {
    return null
  }

  const label = isProductionHost() ? 'Internal testing' : 'Test environment'

  return (
    <div aria-hidden className={styles.badge}>
      <span className={styles.dot} />
      {label}
    </div>
  )
}
